// /join-a-circle — public ad-entry landing for the "join-circle" journey.

import { useEffect } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { EntryJourneyLanding } from '@/components/entry-journeys';
import { useEntryJourneyCopy } from '@/components/entry-journeys/journey-copy';
import { writeEntryJourney } from '@/lib/entry-journey';
import { refSearchParam, storeSignupRef } from '@/lib/signup-ref-cookie';

export const Route = createFileRoute('/_public/join-a-circle')({
  // Signed-in visitors browse the Circles directory instead of the pitch;
  // mid-onboarding visitors re-enter the journey onboarding (see the layout
  // gate exemption in _public.tsx).
  beforeLoad: ({ context }) => {
    if (context.session !== null) {
      if (context.member !== null && context.member.onboardingCompletedAt === null) {
        writeEntryJourney('join-circle');
        throw redirect({ to: '/onboarding/j/about' });
      }
      throw redirect({ to: '/circles' });
    }
  },
  validateSearch: (search: Record<string, unknown>) => refSearchParam(search),
  component: JoinCircleEntryPage,
});

function JoinCircleEntryPage() {
  const { ref } = Route.useSearch();
  // Cookie the campaign ref on arrival (signed-out only — beforeLoad already
  // bounced signed-in visitors) so it survives the signup + OAuth round-trip;
  // /auth/finishing claims it. The URL stays clean from here on.
  useEffect(() => {
    if (ref !== undefined) storeSignupRef(ref);
  }, [ref]);
  return (
    <EntryJourneyLanding
      journey="join-circle"
      {...useEntryJourneyCopy('join-circle')}
    />
  );
}
